module.exports = __webpack_public_path__ + "static/media/download3.3e68266b.png";